<template >
    <div >
        <v-card 
            v-if="!isExporting"
            class="mx-8 mb-2"
            elevation="0"
            @drop="handleFileDrop"
            id="exportForm"
        >
            <v-container fluid fill-height>
                <v-row v-if="files.length == 0">
                    <v-col cols="12" align="center">
                        <v-icon size="100"> mdi-upload </v-icon>
                        <div class="overline font-weight-light">
                            Arrastre archivos o haga click para {{ message }}
                        </div>
                    </v-col>
                </v-row>
                <v-row v-else>
                    <v-col
                        :cols="multiple ? 4 : 12"
                        v-for="(file, index) in files"
                        :key="index"
                        class="d-flex justify-center"
                    >
                        <v-badge color="error" icon="mdi-arrow-up-bold" overlap>
                            <v-icon color="green accent-1" size="100">
                                mdi-file
                            </v-icon>
                            <div class="mt-n16 absolute overline">
                                {{ file.name }}
                            </div>
                            <div class="mt-n13 absolute grey--text overline">
                                {{ (file.size / (1024 * 1024)).toFixed(1) }} MB
                            </div>
                        </v-badge>
                    </v-col>
                </v-row>
            </v-container>
            <input
                v-if="multiple"
                type="file"
                name="file-input"
                multiple
                @change="handleFileInput"
            />
            <input
                v-else
                type="file"
                name="file-input"
                @change="handleFileInput"
            />
        </v-card>
        <v-card elevation="0" v-else>
            <v-row class="px-5">
                <v-col cols="10" class="overline grey--text">
                    {{ action }} ...
                </v-col>
                <v-col cols="2" class="overline grey--text">
                    {{ getTimeAndPercentage() }}
                </v-col>
            </v-row>
            <v-row>
                <v-progress-linear
                    class="mx-8 my-4"
                    :value="exportingProgress"
                    :indeterminate="exportingProgress == 0"
                    height="4"
                    color="#4CAF50"
                    background-color="grey lighten-2"
                >
                </v-progress-linear>
            </v-row>
        </v-card>
    </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
    name: 'UploadForm',
    elapsed: 0,
    props: {
        multiple: {
            type: Boolean,
            default: false,
        },
        message: '',
        action: '',
    },
    data: () => ({}),
    methods: {
        handleFileDrop(e) {
            let droppedFiles = e.dataTransfer.files;

            if (!droppedFiles) return;
            else {
                this.files = [];

                for (let i = 0; i < Object.keys(droppedFiles).length; i++) {
                    if (
                        droppedFiles[i].name.split('.').pop().toLowerCase() ==
                        'xlsx'
                    )
                        this.files.push(droppedFiles[i]);
                    else
                        this.$store.dispatch(
                            'util/showStatusSnackBar',
                            {
                                statusType: 'error',
                                message:
                                    'El archivo ' +
                                    droppedFiles[i].name +
                                    ' no es de tipo XLSX',
                            },
                            { root: true }
                        );
                }
            }
        },
        handleFileInput(e) {
            let files = e.target.files;

            if (!files) return;
            else {
                this.files = [];

                for (let i = 0; i < Object.keys(files).length; i++) {
                    if (files[i].name.split('.').pop().toLowerCase() == 'xlsx')
                        this.files.push(files[i]);
                    else
                        this.$store.dispatch(
                            'util/showStatusSnackBar',
                            {
                                statusType: 'error',
                                message:
                                    'El archivo ' +
                                    files[i].name +
                                    ' no es de tipo XLSX',
                            },
                            { root: true }
                        );
                }
            }
        },
        formatTime(time) {
            let seconds = Math.floor((time / 1000) % 60);
            let minutes = Math.floor((time / (1000 * 60)) % 60);
            let hours = Math.floor((time / (1000 * 60 * 60)) % 24);

            return `${hours}h ${minutes}m ${seconds}s`;
        },
        getTimeAndPercentage(){
            if(this.exportingProgress != 0 && !isNaN(this.exportingProgress)){
                let percent = `${this.exportingProgress.toFixed(0)} %`;
                let formattedTime = this.formatTime(
                    (new Date().getTime() - this.elapsed) * (100 - this.exportingProgress) / this.exportingProgress
                );

                console.log(formattedTime);
            
                return `${percent} - ${formattedTime}`;
            }
        },
    },
    computed: {
        files: {
            get() {
                return this.$store.state.gerencia.files;
            },
            set(val) {
                this.$store.commit('gerencia/files', val);
            },
        },
        ...mapState('util', {
            exportingProgress: (state) => state.exportingProgress,
            isExporting: (state) => state.isExporting,
        }),
    },
    watch: {
        isExporting(val) {
            if (val) {
                console.log('start');
                this.elapsed = new Date().getTime();
            }
        },
    }
};
</script>

<style scoped>
.absolute {
    position: absolute;
}

#exportForm input {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -100px;
    margin-left: -250px;
    width: 500px;
    height: 200px;
    opacity: 0;
}
</style>
